(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('sticky', function($window, scrollService) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            customClass: '@',
            specificPosition: '@'
        },
        template: '<div ng-style="style" ng-transclude></div>',

        link(scope, element) {
            scope.style = {};
            let isStuck = false;
            let contentY = 0; //to track the position of the element before we changed it's style

            function stick() {
                if (scope.customClass) {
                    if (scope.specificPosition) {
                        // apply custom class and fade in
                        element
                        .stop()
                        .css({ opacity: 0 })
                        .addClass(scope.customClass)
                        .animate({ opacity: 1 }, 300);
                    } else {
                        // just apply custom class
                        element.addClass(scope.customClass);
                    }
                } else {
                    scope.style = { position: 'fixed', top: '0', width: `${element.width()}px` };
                }
                isStuck = true;
            }

            function unstick() {
                if (scope.customClass) {
                    if (scope.specificPosition) {
                        // fade out and remove custom class
                        element
                        .stop()
                        .animate({ opacity: 0 }, 300, function() {
                            element.removeClass(scope.customClass);
                        });
                    } else {
                        // just remove custom class
                        element.removeClass(scope.customClass);
                    }
                } else {
                    scope.style = {};
                }
                isStuck = false;
            }

            function checkPosition() {
                const scrollY = scrollService.getScrollOffsets($window).y;

                if (scope.specificPosition) {
                    if (!isStuck && scrollY >= scope.specificPosition) {
                        scope.$apply(function() { stick(); });
                    } else if (isStuck && scrollY < scope.specificPosition) {
                        scope.$apply(function() { unstick(); });
                    }
                } else {
                    const origContentY = element.offset().top; //get actual position

                    if (!isStuck && scrollY > origContentY) {
                        scope.$apply(function() {
                            stick();
                            contentY = origContentY;
                        });
                    } else if (isStuck && scrollY < contentY) {
                        scope.$apply(function() {
                            unstick();
                        });
                    }
                }
            }

            $(window).on('scroll.sticky', checkPosition);

            scope.$on('$destroy', function() {
                $(window).off('scroll.sticky');
            });
        }
    };
});
})();
